import { render, staticRenderFns } from "./CompanyAddressCreate.vue?vue&type=template&id=6a5c7552&"
import script from "./CompanyAddressCreate.vue?vue&type=script&lang=js&"
export * from "./CompanyAddressCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports